import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function PickupDurationDetails({ label, duration }) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={duration}
            />
        </EuiFlexItem>
    );
}
